import React, { forwardRef, useCallback, type Ref } from 'react';
import CustomizeIcon from '@atlaskit/icon/core/customize';
import { ButtonMenuItem, type ButtonMenuItemProps } from '@atlaskit/navigation-system';
import { useFormattedMessageAndIcon } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/use-formatted-message-and-icon/index.tsx';
import { useSectionItemAnalytics } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/utils/use-section-item-analytics/index.tsx';
import type { UIAnalyticsEvent } from '@atlassian/jira-product-analytics-bridge';
import { SECTION_ITEM_CUSTOMIZE_SIDEBAR } from '@atlassian/jira-navigation-apps-sidebar-nav4-analytics/src/common/constants/analytics/section-type.tsx';
import messages from './messages.tsx';

export type CustomizeSidebarMenuItemProps = Pick<ButtonMenuItemProps, 'onClick'>;

export const CustomizeSidebarMenuItem = forwardRef(
	({ onClick }: CustomizeSidebarMenuItemProps, ref: Ref<HTMLButtonElement> | undefined) => {
		const { formattedMessage, icon } = useFormattedMessageAndIcon(
			messages.customizeSidebar,
			CustomizeIcon,
		);
		const sendSectionItemAnalyticsEvent = useSectionItemAnalytics();

		const onClickHandler = useCallback(
			(event: React.MouseEvent<HTMLButtonElement>, analyticsEvent: UIAnalyticsEvent) => {
				sendSectionItemAnalyticsEvent({
					sectionItem: SECTION_ITEM_CUSTOMIZE_SIDEBAR,
				});
				onClick?.(event, analyticsEvent);
			},
			[onClick, sendSectionItemAnalyticsEvent],
		);

		return (
			<ButtonMenuItem
				interactionName="nav4-sidebar-customise-modal"
				elemBefore={icon}
				onClick={onClickHandler}
				ref={ref}
			>
				{formattedMessage}
			</ButtonMenuItem>
		);
	},
);
